export default __webpack_public_path__ + "static/media/noterbanner.8affb4a4.png";